import React from 'react';

import NoDataIcon from 'icons/nodata.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function NoDataMessage({ message }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div className='tw-absolute tw-bottom-[86px] tw-left-0 tw-right-0 tw-flex tw-flex-col tw-items-center tw-justify-end'>
      <NoDataIcon
        className='tw-mb-4 [&_path]:tw-fill-grey-300'
        height={41}
        width={64}
      />
      <div className='tw-mb-1 tw-font-medium tw-text-grey-700'>
        {i18nTShared('noDataToDisplay')}
      </div>
      <div className='tw-text-grey-500'>{message}</div>
    </div>
  );
}

NoDataMessage.propTypes = {
  message: PropTypes.node.isRequired,
};
